import { Avatar, Tag, Tooltip, theme } from "antd";
import { Flex } from "src/components/Flex";
import { IntegrationIcon } from "src/components/IntegrationIcon";
import { useOrg } from "src/hooks/useOrg";
import { formatTime } from "src/utils/date";

export const MiniEventCard = (props: { event: any }) => {
  const { token } = theme.useToken();
  const orgId = useOrg().id;
  const record = props.event.attributes || {};
  return (
    <div
      className="clickable-row"
      style={{ padding: "10px", borderBottom: "1px solid var(--color-border)" }}
      onClick={() =>
        window.open(`/${orgId}/entity/${record.entityUuid}`, "_blank")
      }
    >
      <Flex spaceBetween>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Flex start>
            <Avatar
              shape="square"
              size="small"
              src={record.actor?.avatarUrl || undefined}
              style={{
                width: 28,
                height: 28,
              }}
            >
              {record.actor?.name
                .split(" ")
                .map((name: string) => (name[0] || "").toLocaleUpperCase())
                .join("")}
            </Avatar>
            <div
              style={{ flex: 1, minWidth: 0, paddingLeft: 4, paddingRight: 4 }}
            >
              <div
                style={{
                  lineHeight: "1em",
                  overflow: "visible",
                  fontSize: 11,
                  color: token.colorTextTertiary,
                  fontWeight: 500,
                }}
                className="open-entity"
              >
                <span style={{ opacity: 0.7 }}>by </span>
                {record.actor?.name}
                <span style={{ opacity: 0.7 }}> on </span>
                {formatTime(record.occurredAt, "MMMM D, YYYY")}
                <span style={{ opacity: 0.7 }}> at </span>
                {formatTime(record.occurredAt, "h:mm a")}
              </div>
              <Tooltip
                mouseEnterDelay={1}
                mouseLeaveDelay={0}
                title={record.description}
                placement="topLeft"
              >
                <div
                  className="open-entity trunc"
                  style={{ paddingTop: 2, lineHeight: 1.1, fontSize: 14 }}
                >
                  {record.description}
                </div>
              </Tooltip>
            </div>
          </Flex>
        </div>

        <div
          className="open-entity"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 5,
            minWidth: 0,
          }}
        >
          {record.Action && <Tag className="tag">{record.Action}</Tag>}
          {record.EntityType && <Tag className="tag">{record.EntityType}</Tag>}
          <Tag className="tag">
            <IntegrationIcon
              size={"xsmall"}
              source={`${record.integration}`}
              style={{ marginRight: 10 }}
            />
            {record.integration}
          </Tag>
        </div>
      </Flex>
    </div>
  );
};
